import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import './BaseModal.scss';
import { Button } from '../../FormComponents/Buttons/Button';

type Props = {
  isOpen: boolean;
  contentLabel?: string;
  handleCloseModal: () => void;
  ariaHideApp: boolean;
  title: string;
  isDirty?: boolean;
};

export const BaseModal: React.FC<Props> = ({
  isOpen,
  contentLabel,
  handleCloseModal,
  ariaHideApp,
  title,
  isDirty = false,
  children,
}) => {
  const { t } = useTranslation();
  const [showConfirm, setShowConfirm] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pendingClose, setPendingClose] = useState(false);
  
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '6px',
      overflow: 'visible',
    },
  };

  const handleRequestClose = () => {
    if (isDirty) {
      setPendingClose(true);
      setShowConfirm(true);
    } else {
      handleCloseModal();
    }
  };

  const handleConfirmClose = (confirm: boolean) => {
    setShowConfirm(false);
    if (confirm) {
      handleCloseModal();
    } else {
      setPendingClose(false);
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        contentLabel={contentLabel}
        onRequestClose={handleRequestClose}
        appElement={document.getElementById('root') || undefined}
        ariaHideApp={ariaHideApp}
        style={customStyles}
      >
        <div className="ReactModal__Content__Title">
          <h2>{t(title)}</h2>
        </div>
        <div className="ReactModal__Content__Body">{children}</div>
      </Modal>
      <Modal
        isOpen={showConfirm}
        contentLabel="Confirm Close"
        onRequestClose={() => handleConfirmClose(false)}
        appElement={document.getElementById('root') || undefined}
        ariaHideApp={ariaHideApp}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '6px',
          },
        }}
      >
        <div>
          <p>{t('You have unsaved changes. Are you sure you want to close?')}</p>
          <br/>
          <div className="button-group">
            <Button
              translationKey="button.yes"
              variant="primary"
              color="pink"
              onClick={() => handleConfirmClose(true)}
              type={undefined}
            />
            <Button
              translationKey="button.no"
              variant="primary"
              color="red"
              onClick={() => handleConfirmClose(false)}
              type={undefined}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
